export default "__VITE_ASSET__BrIDr9o$__"